module.exports = __webpack_public_path__ + "img/insta-download.546ddbaf.svg";